module.exports = __webpack_public_path__ + "static/img/HY-V1.b5a72463.png";